export default __webpack_public_path__ + "static/media/buy.86dbc3b6.svg";